import _ from "lodash";

export const trimUserAssignments = (userAssignments) =>
  (userAssignments || [])
    .map(({ userId, exclude }) => ({ userId, exclude }))
    .sort((a, b) => {
      if (a.userId === b.userId) {
        return Number(a.exclude) - Number(b.exclude);
      }
      const aId = String(a.userId);
      const bId = String(b.userId);
      return aId.localeCompare(bId);
    });

export const getIsFormDirty = ({
  permission,
  permissionData,
  permissionId,
}) => {
  if (!permissionData) return false;

  const isRightsDirty = !_.isEqual(
    [...(permission?.rights || [])].sort(),
    [...(permissionData?.rights || [])].sort()
  );

  const isAdGroupsDirty = !_.isEqual(
    [...(permission?.adGroupAssignments || [])].sort(),
    [...(permissionData?.adGroupAssignments || [])].sort()
  );

  const isUserAssignmentsDirty = !_.isEqual(
    trimUserAssignments(permission?.userAssignments),
    trimUserAssignments(permissionData?.userAssignments)
  );

  const isCoreDirty =
    !permissionId ||
    permission?.name !== permissionData?.name ||
    permission?.description !== permissionData?.description;

  return (
    isCoreDirty || isAdGroupsDirty || isUserAssignmentsDirty || isRightsDirty
  );
};
